import {
  __export
} from "./chunk-J5LGTIGS.mjs";

// src/SqliteMigrator.ts
var SqliteMigrator_exports = {};
__export(SqliteMigrator_exports, {
  MigrationError: () => MigrationError,
  fromBabelGlob: () => fromBabelGlob,
  fromGlob: () => fromGlob,
  fromRecord: () => fromRecord,
  layer: () => layer,
  make: () => make2,
  run: () => run
});
import * as Layer from "effect/Layer";
import * as Migrator from "effect/unstable/sql/Migrator";
import { MigrationError, fromBabelGlob, fromGlob, fromRecord, make as make2 } from "effect/unstable/sql/Migrator";
var run = Migrator.make({});
var layer = (options) => Layer.effectDiscard(run(options));

export {
  run,
  layer,
  SqliteMigrator_exports,
  MigrationError,
  fromBabelGlob,
  fromGlob,
  fromRecord,
  make2 as make
};
//# sourceMappingURL=chunk-V5IFGTHZ.mjs.map
